import { useMsal } from "@azure/msal-react";
import { alert } from "contexts";
import useDidMount from "hooks/useDidMount";
import { useMutation } from "react-query";
import { authSignInService } from "services";
import { useAppDispatch } from "stores";
import { fetchingUserSessionAction } from "stores/Auth";
import { saveAccessToken } from "utils";

export const AzureInitializer = () => {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();

  const signInMutation = useMutation(authSignInService, {
    onSuccess: (res) => {
      const accessToken = res?.data?.accessToken;
      if (!accessToken) return;
      saveAccessToken(accessToken);
      dispatch(fetchingUserSessionAction());
    },
  });

  useDidMount(() => {
    instance
      .handleRedirectPromise()
      .then((azureRes) => {
        if (!azureRes) return;
        signInMutation.mutate({
          provider: "azure",
          authData: {
            accessToken: azureRes?.accessToken,
            idToken: azureRes?.idToken,
            oid: (azureRes?.idTokenClaims as { oid: string })?.oid,
          },
        });
      })
      .catch(() => {
        alert({
          title: "Failure",
          content: "Login failed! Please ensure your credentials are valid.",
        });
      });
  });

  return null;
};
